import React from 'react'
import '../style/invitePop.scss'
import Clipboard from 'clipboard'
import QRCode from 'qrcode'
import { util } from '../config'
class InvitePop extends React.Component {
  constructor(props) {
    super();
    this.state = {
      inviteUrl: ''
    }
  }

  componentDidMount() {
    const clipboard = new Clipboard('.copy-btn');
    clipboard.on('success', function () {
      util.showToast({ msg: '复制成功！赶紧邀请你的好友加入吧！' })
    })
  }

  componentDidUpdate(prevProps) {
    if (prevProps.inviteCode !== this.props.inviteCode && this.props.inviteCode !== "") {
      const inviteUrl = 'https://actblood.web.sdo.com/Project/20200921_Kill_2nd/index.html?code=' + this.props.inviteCode;
      QRCode.toDataURL(inviteUrl, { width: '130', height: '130' }).then(url => {
        document.querySelector('.qrcode img').src = url;
      })
      this.setState({ inviteUrl })
    }
  }

  render() {
    return (
      <div className="popup invite-pop">
        <div className="content">
          <div className="code-container">
            <div className="qrcode"><img src="" alt="" /></div>
            <div className="link-container">{this.state.inviteUrl}</div>
            <button className="copy-btn" data-clipboard-text={this.state.inviteUrl}></button>
            <p>* 复制上方专属邀请链接，发送伙伴进行预约</p>
            <p>* 邀请已预约的伙伴，不计入成功邀请。</p>
          </div>
          <div className="close" onClick={this.props.toggleInvitePop}></div>
        </div>
      </div>
    )
  }
}
export default InvitePop;
